module.exports = __webpack_public_path__ + "img/login_logo.a9a4f747.png";